// Copyright 2026. WebPros International GmbH. All rights reserved.

import {
    Icon,
    Text,
} from '@plesk/ui-library';
import { ReactNode } from 'react';

interface IProps {
    children: ReactNode;
}

export default function ErrorMessage({ children }: IProps) {
    return (
        <Text component={'p'}>
            <Icon name={'exclamation-mark-circle'} intent="danger" style={{ marginRight: 4 }} />

            {children}
        </Text>
    );
}